import Vue from 'vue'
import ChildAvatar from '@/components/Child/ChildAvatar.vue'
import MapTooltip from '@/components/Map/MapTooltip.vue'

import store from '@/store/store.js'

const Marker = Vue.extend(ChildAvatar)
const Tooltip = Vue.extend(MapTooltip)

const createOverlay = (type, data) => {
  switch (type) {
    case 'marker': return new Marker({
      store,
      propsData: {
        child: data,
        showOutOfSync: true
      }
    })

    case 'tooltip': return new Tooltip({
      store,
      propsData: {
        child: data
      }
    })

    default: 
      console.error(`OVERLAY_TYPE_ERROR. Valid types: marker :: tooltip. Got - "${type}"`)
      
      return false
  }
}

export default function CustomOverlay(data) {
  this.setMap(data.map)
  this.type_ = data.type
  this.body_ = data.body
  this.latlng_ = new google.maps.LatLng(
    data.body.latest_location.latitude,
    data.body.latest_location.longitude
  )
}

CustomOverlay.prototype = new google.maps.OverlayView()

CustomOverlay.prototype.draw = function() {
  const me = this

  // Check if the div has been created.
  let div = this.div_

  if (!div) {

    // Create a overlay text DIV
    div = this.div_ = document.createElement('div')

    // Create the DIV representing our CustomOverlay
    div.className = this.type_

    // Create custom Overlay
    let element = createOverlay(this.type_, this.body_)
    element.$mount()

    div.appendChild(element.$el)

    div.addEventListener('click', function() {
      google.maps.event.trigger(me, 'click')
    })

    // Then add the overlay to the DOM
    let panes = this.getPanes()
    panes.overlayImage.appendChild(div)
  }

  // Position the overlay 
  let point = this.getProjection().fromLatLngToDivPixel(this.latlng_)

  if (point) {
    div.style.left = point.x + 'px'
    div.style.top = point.y + 'px'
  }
}

CustomOverlay.prototype.onRemove = function() {
  this.div_.parentNode.removeChild(this.div_);
  this.div_ = null;
}
